export default __webpack_public_path__ + "static/media/photo--sm--misc-17.3bc2338f.jpg";